export default "__VITE_ASSET__B_aEZtM6__"